
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import GeneralVehicleSelect from "@common/src/components/scope/vehicle-select/index.vue";
import BtnCheck from "@/components/scope/btn-check.vue";
import BtnCheckGroup from "@common/src/components/scope/btn-check-group/index.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import CustomerFlagSelect from "@common/src/components/scope/flag-select/index.vue";
import NextMaintenanceDatePicker from "@common/src/components/scope/next-maintenance-datepicker/index.vue";
import NextMileageInput from "@common/src/components/scope/next-mileage-input/index.vue";
import RepeatOrderDialog from "@common/src/components/scope/repeat-order-dialog/index.vue";
import TechnicianTips from "./components/technician-tips.vue";

import {
  priceRulesEl,
  mobileRulesEl,
  partsQuantityRules,
  priceRules,
  plateCodeRuleEl,
  isPositiveInteger,
  mileageRulesEl
} from "@common/src/utils/verify";

Component.registerHooks(["beforeRouteLeave"]);
const staff = namespace("staff");
const customer = namespace("customer");
const serviceItem = namespace("service-item");
const service = namespace("service");
const parts = namespace("parts");
const partsCategory = namespace("parts-category");
const user = namespace("user");
const app = namespace("app");
const inventory = namespace("inventory");
const setting = namespace("setting");
const common_base = namespace("common_base");
const common_app = namespace("common_app");
@Component({
  components: {
    GeneralVehicleSelect,
    BtnCheck,
    BtnCheckGroup,
    MyCheckbox,
    CustomerFlag,
    CustomerFlagSelect,
    NextMaintenanceDatePicker,
    NextMileageInput,
    RepeatOrderDialog,
    TechnicianTips
  }
})
export default class ServiceEdit extends Vue {
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @staff.Action getTechnicianStaffList;
  @customer.Action getCustomerList;
  @customer.Action getCustomerDetail;
  @serviceItem.Action getServiceItemList;
  @serviceItem.Action getServiceDetail;
  @customer.Action saveCustomer;
  @service.Action createMaintenanceOrder;
  @service.Action getAppointmentCalender;
  @service.Action createWashOrder;
  @service.Action createRetailOrder;
  @service.Action checkRepeatCreateOrder;
  @parts.Action getPartsInventoryList;
  @parts.Action getPartsDetail;
  @service.Action getOrderDetail;
  @service.State technicianTipsAutoShow;
  @service.Mutation setTechnicianTipsAutoShow;
  @service.Action updateOrder;
  @partsCategory.Action getCategoryList;
  @parts.Action createParts;
  @inventory.Action queryPartsInventoryOnBatch;
  @user.State userData;
  @app.State btnLoading;
  @common_app.State country;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Getter isOpenDispatch;
  @common_base.State showPlatformParts;
  @common_base.State showPlatformServiceItem;
  @common_app.State lang;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  get breadData() {
    let typeStr = "";
    if (this.orderType === "maintenance") {
      typeStr = t("test.new-maintenance-service");
    }
    if (this.orderType === "wash") {
      typeStr = t("test.new-car-wash-service");
    }
    if (this.orderType === "retail") {
      typeStr = t("test.new-retail-service");
    }
    return [
      { name: t("test.service-management"), path: "/service/index" },
      { name: this.isAdd ? typeStr : t("service.edit-service-information") }
    ];
  }
  get isAdd() {
    return this.$route.name === "serviceAdd";
  }
  get isArriveOperate() {
    return this.$route.query.pageType === "arrive";
  }
  valueMapping: any = {
    "1": "maintenance",
    "2": "wash",
    "3": "retail"
  };
  orderTypeCodeMap: any = {
    maintenance: "1",
    wash: "2",
    retail: "3"
  };
  get orderType() {
    return this.$route.query.type || this.valueMapping[this.orderFormData.orderType];
  }
  showSetArriveStoreDate: boolean = false; // 是否显示设置到店时间
  arriveStoreDate: string = dayjs().format("YYYYMMDD"); // 预约到店时间
  arriveTimeArr: any = [
    ["07", "08"],
    ["08", "09"],
    ["09", "10"],
    ["10", "11"],
    ["11", "12"],
    ["12", "13"],
    ["13", "14"],
    ["14", "15"],
    ["15", "16"],
    ["16", "17"],
    ["17", "18"],
    ["18", "19"],
    ["19", "20"],
    ["20", "21"],
    ["21", "22"]
  ];
  chooseTimeIndex: number = -1;
  todayTimeStamp = dayjs().startOf("day").valueOf();
  disableTimeStamp: number = dayjs().add(2, "month").valueOf();
  datePickerOptions: any = {};
  todayAppointmentData: any = {};
  get arriveTimeDisableArr() {
    return this.arriveTimeArr.map(time => {
      return time[0] <= dayjs().get("hour") && this.arriveStoreDate === dayjs().format("YYYYMMDD");
    });
  }
  getAppointmentData() {
    // 获取预约时间日历数据
    this.getAppointmentCalender().then(data => {
      if (data?.data?.list) {
        this.appointmentData = data.data.list;
      }
      this.handleChooseDate(this.arriveStoreDate);
      this.setPickerOptions();
    });
  }
  get hasAppointmentDate() {
    return this.appointmentData.map(item => item.date);
  }
  setPickerOptions() {
    this.datePickerOptions = {
      disabledDate: val => {
        let timestamp = dayjs(val).valueOf();
        return !(timestamp >= this.todayTimeStamp && timestamp <= this.disableTimeStamp);
      },
      cellClassName: val => {
        if (this.hasAppointmentDate.includes(dayjs(val).format("YYYYMMDD"))) {
          return "point";
        }
        return "";
      }
    };
  }
  handleChooseTime(i, disable) {
    if (disable) return;
    this.chooseTimeIndex = i;
  }
  appointmentData: any = [];
  handleChooseDate(val) {
    console.log(val);
    this.chooseTimeIndex = -1; // 切换日期清空时间段选择
    this.todayAppointmentData = {};
    let thisDay = this.appointmentData.find(item => {
      return item.date === val;
    });
    if (thisDay) {
      let temp = {};
      thisDay.reservationHours.forEach(item => {
        temp[item.hour] = item.reservationOrderCount;
      });
      this.todayAppointmentData = temp;
    }
  }
  handleAppointment() {
    if (!this.arriveStoreDate || this.chooseTimeIndex < 0) {
      return this.$message.error(t("service.choose-your-arrival-time"));
    }
    this.showSetArriveStoreDate = false;
    let date = this.arriveStoreDate + this.arriveTimeArr[this.chooseTimeIndex][0];
    this.orderFormData.reservationArrivalTime = date;
  }
  handleSettingArriveTime() {
    this.showSetArriveStoreDate = true;
  }
  quitNext: any;
  shwoAddServiceModal: boolean = false; // 快捷添加服务modal框显示/隐藏
  shwoQuitConfirm: boolean = false;
  beforeRouteLeave(to, from, next) {
    if (this.isAdd && to.name !== "serviceView" && this.watchOrderNum > 2) {
      this.shwoQuitConfirm = true;
      this.quitNext = next;
      next(false);
    } else {
      next();
    }
  }
  // 控制form disable状态
  formDisableStatus = {
    plateCode: false,
    customerModelCode: false,
    customerName: false,
    customerMobile: false
  };
  appointmentTimeFromat(time) {
    return `${time.substr(0, 4)}-${time.substr(4, 2)}-${time.substr(6, 2)} ${time.substr(8, 2)}:00 - ${
      Number(time.substr(8, 2)) + 1
    }:00`;
  }
  categoryCasProps: any = {
    label: "categoryName",
    value: "categoryCode"
  };
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  advisorList: any = [{}];
  technicianStaffList: any = [];
  defaultVehicleList: any = [];
  emptyToLine = emptyToLine;
  showSelectCustomer: boolean = false;
  showAdditional: boolean = false;
  orderFormData: any = {
    externalCustomerFlag: "0",
    orderDateType: "1", // 1到店 2预约到店
    reservationArrivalTime: "",
    orderAmount: "0",
    additionalFees: "",
    additionalFeesRemark: "",
    advisorCode: "",
    customerCode: "",
    customerCurrentMileage: "",
    customerMobile: "",
    customerModelCode: "",
    modelRemark: "",
    customerName: "",
    customerNextMaintenanceDate: "",
    customerNextMileage: "",
    customerOilVolume: 0,
    leaveTime: dayjs().format("YYYYMMDD"),
    plateCode: "",
    partsDetail: [],
    serviceDetail: [],
    storeRemark: "", // 客户备注
    deliverymanName: "", // 送修人
    deliverymanMobile: "" // 送修人手机号
  };
  get additionalData() {
    return [
      {
        additionalFees: this.orderFormData.additionalFees,
        additionalFeesRemark: this.orderFormData.additionalFeesRemark
      }
    ];
  }
  customerFormRules: any = {
    plateCode: [{ required: true, validator: this.validatePlateCode, trigger: "blur" }],
    customerModelCode: [{ required: true, message: t("test.select-car-model"), trigger: "blur" }],
    customerMobile: [{ validator: this.validateMobile, trigger: "blur" }],
    customerCurrentMileage: { validator: this.checkMileage, trigger: "blur" },
    customerNextMileage: { validator: this.checkMileage, trigger: "blur" }
  };
  checkMileage(rule, value, callback) {
    mileageRulesEl(value, callback, true);
  }
  validateMobile(rule, value, callback) {
    if (!value || this.formDisableStatus.customerMobile) {
      // 如果为空，或者客户信息已经有手机号，不做格式效验
      return callback();
    } else {
      mobileRulesEl(value, callback);
    }
  }
  definitionServiceData: any = {
    serviceCode: "",
    workingHours: "",
    quantity: "", // 次数
    singleWorkingHours: "", // 单次工时
    serviceFee: "", // 服务单价
    amount: "",
    technicianCode: [],
    saleCode: "",
    remark: "",
    manual: true,
    partsList: []
  };
  definitionPartsData: any = {
    partsCode: "",
    partsName: "",
    partsNameDesc: "",
    quantity: "",
    sellingPrice: "",
    technicianCode: [],
    saleCode: "",
    amount: "",
    remark: "",
    manual: true
  };

  serviceItemList: any[] = [];
  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }
  created() {
    this.setPBPX(100);
    this.init();
    this.getAppointmentData();
  }
  async init() {
    await this.getStaffList({
      // 获取所有员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      this.orderFormData.advisorCode = this.userData.userCode;
      this.definitionServiceData.saleCode = this.userData.userCode;
      this.definitionPartsData.saleCode = this.userData.userCode;
    });
    this.getTechnicianStaffList({
      // 获取角色为技师的员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.technicianStaffList = data.data.list;
    });
    if (this.orderType) {
      // 这里有orderType说明是新增
      await this.handleSearchServiceItemList();
    }
    await this.getPartsLists();
    if (!this.isAdd) {
      // 订单编辑
      this.getOrderDetail({
        orderNo: this.orderId
      }).then(data => {
        const serviceCodeMap = {}; // 存放映射关系
        data.data.partsDetail.forEach((parts, index) => {
          if (parts.technicianArray) {
            // 格式化技师code
            parts.technicianCode = parts.technicianArray.map(item => item.technicianCode);
          }
          if (parts.serviceCode) {
            if (serviceCodeMap[parts.serviceCode]) {
              serviceCodeMap[parts.serviceCode].push(index);
            } else {
              serviceCodeMap[parts.serviceCode] = [index];
            }
          }
        });
        data.data.serviceDetail.forEach(serviceItem => {
          if (serviceItem.technicianArray) {
            // 格式化技师code
            serviceItem.technicianCode = serviceItem.technicianArray.map(item => item.technicianCode);
          }
          if (serviceCodeMap[serviceItem.serviceCode]) {
            serviceItem.isGroup = true;
            serviceItem.groupServiceIndex = this.groupIndex;
            serviceCodeMap[serviceItem.serviceCode].forEach(i => {
              data.data.partsDetail[i].isGroupParts = true;
              data.data.partsDetail[i].groupServiceIndex = this.groupIndex;
              data.data.partsDetail[i].requireQuantity = (
                data.data.partsDetail[i].quantity / serviceItem.quantity
              ).i18nToFixed();
            });
            this.groupIndex++;
          }
        });
        //油量回显
        data.data.customerOilVolume = Number(data?.data?.customerOilVolume || 0) * 20;
        data.data.serviceDetail.forEach(item => {
          // 回显并去重
          if (
            !this.serviceItemList.some(serviceItem => {
              return serviceItem.serviceCode === item.serviceCode;
            })
          ) {
            this.serviceItemList.push({
              serviceCode: item.serviceCode,
              serviceName: item.serviceName
            });
          }
        });
        data.data.partsDetail.forEach(item => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push({
              partsCode: item.partsCode,
              partsName: item.partsName,
              partsNameDesc: item.partsNameDesc
            });
          }
        });
        this.customerLabelDescList = data.data.labelDescList; // 客户标签回显
        this.orderFormData = data.data;
        this.orderFormData.leaveTime =
          this.orderFormData.leaveTime && dayjs(this.orderFormData.leaveTime).format("YYYYMMDD");
        this.orderFormData.customerNextMaintenanceDate =
          this.orderFormData.customerNextMaintenanceDate &&
          dayjs(this.orderFormData.customerNextMaintenanceDate).format("YYYYMMDD");
        if (data.data.additionalFees) {
          this.showAdditional = true;
        }
        this.defaultVehicleList = [
          {
            lastValue: data.data.customerModelCode,
            name: data.data.modelDesc
          }
        ];
        this.formDisableStatus.plateCode = true;
        this.formDisableStatus.customerModelCode = true;
        this.formDisableStatus.customerName = !!data.data.customerName;
        this.formDisableStatus.customerMobile = !!data.data.customerMobile;
        // 编辑 才会在这里拉取服务项目
        this.handleSearchServiceItemList();
      });
    } else {
      let customerCode = this.$route.query.customerCode;
      let vehicleCode = this.$route.query.vehicleCode;
      let serviceItemCodes = this.$route.query.serviceItemCodes as any;
      let serviceItemCodeArr = serviceItemCodes ? serviceItemCodes.split(",") : [];
      let partsCodes = this.$route.query.partsCodes as any;
      let partsCodeArr = partsCodes ? partsCodes.split(",") : [];
      serviceItemCodeArr.forEach((item, index) => {
        this.handleAddService();
        this.handleChooseServiceItem(item, index);
      });
      partsCodeArr.forEach((item, index) => {
        this.handleAddParts();
        this.handleChooseParts(item, index);
      });
      if (customerCode) {
        this.setCustomerData(vehicleCode, customerCode);
      }
      if (!serviceItemCodeArr.length && !partsCodeArr.length) {
        this.handleAddService();
      }
    }
  }
  typeOptionsData: any = [
    {
      label: t("service.the-shop-order"),
      value: "1"
    },
    {
      label: t("service.booking-order"),
      value: "2"
    }
  ];
  handleSwitchType(val) {
    if (val === "1") {
      this.orderFormData.reservationArrivalTime = "";
    } else {
      this.orderFormData.leaveTime = "";
    }
  }
  validatePlateCode(rule, value, callback) {
    plateCodeRuleEl(value, callback, this.country);
  }
  // 确认退出
  confirmQuit() {
    this.quitNext();
  }
  getPartsLists(name = "") {
    return this.getPartsInventoryList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.partsNameDesc = item.partsCustomizeCode
          ? `${item.partsNameDesc}(${item.partsCustomizeCode})`
          : item.partsNameDesc;
        return item;
      });
    });
  }
  computedAmount(type, index) {
    console.log(type, index);
    // type: 1-服务，2-零配件，3-附加费
    if (type === 1) {
      const rowData = this.orderFormData.serviceDetail[index];
      const serviceFee = rowData.serviceFee;
      const quantity = rowData.quantity || 0;
      rowData.amount = (serviceFee * quantity).i18nToFixed();
      const serviceCode = rowData.serviceCode;
      this.orderFormData.partsDetail.forEach(parts => {
        console.log(quantity, parts);
        if (serviceCode === parts.serviceCode && parts.groupServiceIndex === rowData.groupServiceIndex) {
          parts.quantity = quantity * (parts.requireQuantity || 0);
        }
      });
    } else if (type === 2) {
      if (this.orderFormData.partsDetail[index].isGroupParts) {
        // 套餐零配件不算钱
        this.orderFormData.partsDetail[index].amount = 0;
        return;
      }
      let amount =
        (this.orderFormData.partsDetail[index].quantity || 0) * this.orderFormData.partsDetail[index].sellingPrice;
      this.orderFormData.partsDetail[index].amount = amount.i18nToFixed();
    } else if (type === 3) {
      //
    }

    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const serviceTotal = this.orderFormData.serviceDetail.reduce((preV, curV) => preV + Number(curV.amount), 0);
    const partsTotal = this.orderFormData.partsDetail.reduce((preV, curV) => preV + Number(curV.amount), 0);
    if (Object.is(NaN, serviceTotal) || Object.is(NaN, partsTotal)) {
      return this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    console.log(serviceTotal, partsTotal);
    this.orderFormData.orderAmount = (
      serviceTotal +
      partsTotal +
      Number(this.orderFormData.additionalFees)
    ).i18nToFixed();
  }
  handleSearchServiceItemList(name = "") {
    this.noMatchingServiceItemName = name;
    this.getServiceItemList({
      pageSize: 20,
      pageNum: 1,
      searchKey: name,
      serviceClass: this.orderType === "maintenance" ? "1" : "2",
      notOpadmin: this.showPlatformServiceItem ? "0" : "1"
    }).then(data => {
      this.serviceItemList = this.$safeValue(data, "data.list", []);
      this.SetServiceItemDisabled();
    });
  }
  SetServiceItemDisabled() {
    this.serviceItemList = this.serviceItemList.map(service => {
      service.disabled = this.orderFormData.serviceDetail.some(item => item.serviceCode === service.serviceCode);
      return service;
    });
  }
  searchParts(val) {
    this.noMatchingPartsName = val;
    this.getPartsLists(val);
  }
  groupIndex: number = 1;
  // val => serviceCode

  handleChooseServiceItem(val, index) {
    let serviceItemRowData = this.orderFormData.serviceDetail[index];
    this.getServiceDetail({
      serviceCode: val
    }).then(data => {
      const serviceData = data.data || {};
      Object.assign(serviceData, {
        serviceFee: serviceData.serviceFee,
        partsList: [],
        technicianCode: serviceItemRowData?.technicianCode || [],
        quantity: 1,
        saleCode: this.userData.userCode,
        isPushMoney: this.getIsPushMoney(val, this.serviceItemList)
      });
      this.orderFormData.serviceDetail.splice(index, 1, serviceData);
      // 套餐项目，并且有零配件
      if (serviceData.serviceType === "2" && serviceData.servicePartsList.length > 0) {
        let _index = (serviceData.groupServiceIndex = this.groupIndex);
        const partsCodeArr = serviceData.servicePartsList.map(parts => parts.partsCode);
        const partsRequireNum = serviceData.servicePartsList.map(parts => parts.servicePartsQty);
        console.log(partsRequireNum);
        this.queryPartsInventoryOnBatch({
          partsCodeArray: partsCodeArr
        }).then(data => {
          const partsArr = data.data;
          partsArr.forEach((item, parstIndex) => {
            let partsData = Object.assign({}, this.definitionPartsData, {
              isGroupParts: true,
              saleCode: "",
              partsName: item.partsName,
              partsNameDesc: item.partsNameDesc,
              partsUnit: item.partsUnit,
              sellingPrice: item.sellingPrice, // 套餐内零配件不算钱
              invQty: item.invQty,
              quantity: partsRequireNum[parstIndex],
              requireQuantity: partsRequireNum[parstIndex],
              partsCode: item.partsCode,
              serviceCode: val,
              groupServiceIndex: _index
            });
            this.orderFormData.partsDetail.push(partsData);
            serviceItemRowData.partsList.push(partsData);
          });
        });
        this.groupIndex++;
      }
      // 添加到服务项列表回显并去重
      if (
        !this.serviceItemList.some(serviceItem => {
          return serviceItem.serviceCode === serviceData.serviceCode;
        })
      ) {
        this.serviceItemList.push(serviceData);
      }
      this.SetServiceItemDisabled();
      this.clearParts();
      this.computedAmount(1, index);
    });
  }
  clearParts() {
    // 清除未匹配的套餐零配件
    const selectedServiceGroupIndexArr = this.orderFormData.serviceDetail.map(item => {
      return item.groupServiceIndex;
    });
    for (let partsIndex = 0; partsIndex < this.orderFormData.partsDetail.length; partsIndex++) {
      let currentParts = this.orderFormData.partsDetail[partsIndex];
      // 是套餐中的零配件，并且下标在项目中不存在
      if (currentParts.serviceCode && !selectedServiceGroupIndexArr.includes(currentParts.groupServiceIndex)) {
        this.orderFormData.partsDetail.splice(partsIndex, 1);
        partsIndex--;
      }
    }
  }
  async handleChooseParts(val, index) {
    let partsData = { isPushMoney: false };
    let partsRowData = this.orderFormData.partsDetail[index];
    const findPardOfList = this.partsList.find(item => item.partsCode === val);
    if (findPardOfList) {
      partsData = Object.assign({}, this.definitionPartsData, findPardOfList, {
        technicianCode: partsRowData?.technicianCode || []
      });
    } else {
      partsData = await this.queryPartsInventoryOnBatch({
        partsCodeArray: [val]
      }).then(data => {
        const partsData = data.data ? data.data[0] : {};
        this.partsList.push(partsData);
        return partsData;
      });
    }
    partsData.isPushMoney = this.getIsPushMoney(val, this.partsList);
    this.orderFormData.partsDetail.splice(index, 1, partsData);
    this.computedAmount(2, index);
  }
  submitForm() {
    if (!this.orderFormData.customerCode) {
      this.$message.error(t("test.search-select-customer"));
      return;
    }
    (this.$refs["customerForm"] as any).validate(async valid => {
      if (valid && this.checkAddData()) {
        if (this.isAdd) {
          // this.createService();
          this.checkLastOrderData = await this.beforeSubmitCheck();
          if (!this.checkLastOrderData) {
            this.createService();
          }
        } else {
          this.editService();
        }
      } else {
        console.log("error submit!!");
      }
    });
  }
  checkLastOrderData: any = {};
  beforeSubmitCheck() {
    return this.checkRepeatCreateOrder({
      mobile: this.orderFormData.customerMobile,
      orderType: this.orderTypeCodeMap[this.orderType],
      plateCode: this.orderFormData.plateCode
    }).then(data => {
      return data.data;
    });
  }
  checkAddData(): boolean {
    if (this.orderFormData.orderDateType === "2" && !this.orderFormData.reservationArrivalTime) {
      this.$message.error(t("service.appointment-your-arrival-time"));
      return false;
    }
    if (this.orderFormData.storeRemark && this.orderFormData.storeRemark.length > 50) {
      this.$message.error(t("v213.store-remarks-can-be-up-to-characters-long"));
      return false;
    }

    if (this.orderType !== "retail" && this.orderFormData.serviceDetail.length < 1) {
      this.$message.error(t("service.add-least-service-item"));
      return;
    }
    for (let index = 0; index < this.orderFormData.serviceDetail.length; index++) {
      const element = this.orderFormData.serviceDetail[index];
      if (!element.serviceCode) {
        this.$message.error(t("service.select-service-item"));
        return false;
      }
      if (!element.quantity || !isPositiveInteger(element.quantity)) {
        this.$message.error(t("v270.the-number-of-items-must-be-a-positive"));
        return false;
      }

      if (
        !this.isOpenDispatch &&
        this.orderType !== "wash" &&
        (this.orderFormData.orderDateType === "1" || this.isArriveOperate) &&
        element.technicianCode &&
        element.technicianCode.length === 0
      ) {
        this.$message.error(t("service.select-service-technician"));
        return false;
      }
    }
    if (this.orderType === "retail" && this.orderFormData.partsDetail.length < 1) {
      this.$message.error(t("service.add-least-one-widget"));
      return;
    }
    for (let index = 0; index < this.orderFormData.partsDetail.length; index++) {
      const element = this.orderFormData.partsDetail[index];
      if (!element.partsCode) {
        this.$message.error(t("setting.select-spare-parts"));
        return false;
      }
      if (!element.quantity) {
        this.$message.error(t("service.fill-number-spare-parts"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.quantity);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (!element.isGroupParts && !element.sellingPrice) {
        this.$message.error(t("service.fill-unit-price-spare-parts"));
        return false;
      }
    }
    if (this.orderFormData.additionalFees && !priceRules(this.orderFormData.additionalFees).success) {
      this.$message.error(t("service.input-additional-fee-format"));
      return false;
    }
    return true;
  }
  customerLabelDescList: any = [];
  saveCustomerInfo() {
    const customerSaveData = {
      customerCode: this.orderFormData.customerCode,
      vehicle: {
        vehicleCode: this.orderFormData.vehicleCode,
        plateCode: this.orderFormData.plateCode,
        modelCode: this.orderFormData.customerModelCode,
        labelDescList: this.customerLabelDescList
      },
      customerName: this.orderFormData.customerName,
      mobile: this.orderFormData.customerMobile
    };
    this.btnStartLoading();
    return this.saveCustomer(customerSaveData)
      .then(() => {})
      .finally(() => {
        this.btnStopLoading();
      });
  }
  async createService() {
    let result;
    await this.saveCustomerInfo();
    this.setTechnicianArray(); // 技师Code format成对象数组
    this.btnStartLoading();
    try {
      if (this.orderType === "maintenance") {
        result = await this.createMaintenanceOrder(this.orderFormData);
      } else if (this.orderType === "wash") {
        result = await this.createWashOrder(this.orderFormData);
      } else {
        result = await this.createRetailOrder(this.orderFormData);
      }
      this.$message.success(t("base.create-success") as string);
      this.$router.push(`/service/view/${result.data.orderNo}`);
      this.quitNext();
    } catch (e) {
      console.log(e);
      this.btnStopLoading();
    }
  }
  setTechnicianArray() {
    this.orderFormData.serviceDetail.forEach(serviceItem => {
      serviceItem.technicianArray = (serviceItem?.technicianCode || []).map(item => ({
        technicianCode: item
      }));
      serviceItem.technicianCodes = (serviceItem?.technicianCode || []).join();
    });
    this.orderFormData.partsDetail.forEach(serviceItem => {
      serviceItem.technicianArray = (serviceItem?.technicianCode || []).map(item => ({
        technicianCode: item
      }));
      serviceItem.technicianCodes = (serviceItem?.technicianCode || []).join();
    });
  }
  async editService() {
    await this.saveCustomerInfo();
    this.btnStartLoading();
    this.setTechnicianArray();
    if (this.isArriveOperate) {
      this.orderFormData.arrivalStore = true;
    }
    this.updateOrder(this.orderFormData)
      .then(() => {
        this.$message.success(t("base.update-success") as string);
        this.$router.push(`/service/view/${this.orderId}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  addAdditionCost() {
    // 控制表格显示
    this.showAdditional = true;
  }
  handleAddService() {
    let technicianArray = [];
    if (
      this.orderFormData?.serviceDetail?.[0]?.technicianCode &&
      this.orderFormData.serviceDetail[0].technicianCode.length > 0
    ) {
      technicianArray = this.orderFormData.serviceDetail[0].technicianCode.slice();
    }
    this.orderFormData.serviceDetail.push(
      Object.assign({}, this.definitionServiceData, {
        technicianCode: technicianArray
      })
    );
  }
  handleAddParts() {
    let technicianArray = [];
    if (
      this.orderFormData?.serviceDetail?.[0]?.technicianCode &&
      this.orderFormData.serviceDetail[0].technicianCode.length > 0
    ) {
      technicianArray = this.orderFormData.serviceDetail[0].technicianCode.slice();
    }
    this.orderFormData.partsDetail.push(
      Object.assign({}, this.definitionPartsData, {
        technicianCode: technicianArray
      })
    );
  }
  handleLinkAddParts() {
    const { href } = this.$router.resolve("/setting/parts-add");
    window.open(href);
  }
  deleteItem(key, index) {
    if (key === "serviceDetail" && this.orderFormData.serviceDetail[index].groupServiceIndex) {
      let service = this.orderFormData.serviceDetail[index];
      for (let partsIndex = 0; partsIndex < this.orderFormData.partsDetail.length; partsIndex++) {
        let parts = this.orderFormData.partsDetail[partsIndex];
        if (parts.groupServiceIndex === service.groupServiceIndex) {
          this.orderFormData.partsDetail.splice(partsIndex, 1);
          partsIndex--;
        }
      }
    }
    this.orderFormData[key].splice(index, 1);
    this.SetServiceItemDisabled();
    this.computedTotalAmount();
  }
  deleteAdditional() {
    this.showAdditional = false;
    this.orderFormData.additionalFees = "";
    this.orderFormData.additionalFeesRemark = "";
  }
  linkCreateCustomer() {
    let { href } = this.$router.resolve({
      path: `/setting/customer-add`
    });
    window.open(href, "_blank");
  }

  seletedCustomer: string = "";
  customerList: any[] = [];
  handleShowSelCustomer() {
    this.showSelectCustomer = true;
    this.$nextTick(() => {
      (this.$refs["select-customer"] as any).focus();
    });
  }
  handleSearchCustomer(val) {
    if (val) {
      this.getCustomerList({
        pageSize: 20,
        pageNum: 1,
        searchKey: val
      }).then(data => {
        if (!data.data.list) {
          this.customerList = [];
        } else {
          this.customerList = data.data.list.map(item => {
            item.label = `${item.plateCode}${item.customerName ? "/" + item.customerName : ""} ${
              item.mobile ? "/" + item.mobile : ""
            }`;
            return item;
          });
        }
      });
    } else {
      this.customerList = [];
    }
  }
  handleChooseCustomer(val) {
    const customer = this.customerList.find(item => {
      return val === item.vehicleCode;
    });
    this.orderFormData.customerCode = this.$safeValue(customer, "customerCode", "");
    this.setCustomerData(val, customer?.customerCode);
  }
  setCustomerData(vehicleCode, customerCode) {
    this.getCustomerDetail({
      customerCode: customerCode,
      vehicleCode: vehicleCode
    }).then(data => {
      const customerData = data.data;
      let vehicleList = this.$safeValue(data, "data.vehicleList", []);
      let vehicleData = vehicleList.find(item => {
        return data.data.selectedVehicleCode === item.vehicleCode;
      });
      if (!vehicleData) {
        // 没传车辆code取第一辆
        vehicleData = vehicleList[0] || {};
        vehicleCode = vehicleData.vehicleCode;
      }
      this.orderFormData.customerCode = customerCode;
      this.orderFormData.customerName = customerData?.customerName;
      this.orderFormData.customerMobile = customerData.mobile;
      this.orderFormData.vehicleCode = vehicleCode;
      this.formDisableStatus.customerName = !!customerData.customerName;
      this.formDisableStatus.customerMobile = !!customerData.mobile;

      if (vehicleData) {
        this.orderFormData.plateCode = vehicleData.plateCode || "";
        this.defaultVehicleList = this.vehicleDataFormat([vehicleData]);
        this.orderFormData.customerNextMileage = vehicleData.nextMaintenanceMileage || "";
        this.orderFormData.customerNextMaintenanceDate = vehicleData.nextMaintenanceDate || "";
        this.formDisableStatus.plateCode = !!vehicleData.plateCode;
        this.customerLabelDescList = vehicleData.labelDescList; // 客户标签回显
      }
      this.formDisableStatus.customerModelCode = !!this.defaultVehicleList.length;
      // 获取到车辆信息重新验证格式
      if (this.defaultVehicleList.length) {
        this.$nextTick(() => {
          (this.$refs["customerForm"] as any).validateField("customerModelCode");
        });
      }
      if (this.orderFormData.plateCode) {
        this.$nextTick(() => {
          (this.$refs["customerForm"] as any).validateField("plateCode");
        });
      }
    });
  }
  vehicleDataFormat(data) {
    const tempArr = [];
    data.forEach(item => {
      if (item.brandCode && item.seriesName && item.modelCode) {
        tempArr.push({
          lastValue: item.modelCode,
          name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
          valueGroup: [item.brandCode, item.seriesName, item.modelCode]
        });
      }
    });
    return tempArr;
  }
  handleOpoColse() {
    // 关闭去掉错误状态
    (this.$refs["customerForm"] as any).validateField("customerModelCode");
  }
  watchOrderNum = 0;
  @Watch("orderFormData", { deep: true })
  WatchOrderData() {
    this.watchOrderNum += 1;
  }
  getIsPushMoney(serviceCode, list) {
    // 是否是提成项目或者零配件

    if (serviceCode) {
      let res = list.find(item => serviceCode === item.serviceCode || serviceCode === item.partsCode);

      if (res && res.existCommission === "1") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  handleOpServiceItemShowChange() {
    this.handleSearchServiceItemList();
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  handleConfirmCreateOrder() {
    this.checkLastOrderData = {};
    this.createService();
  }
  noMatchingServiceItemName = "";
  handleLinkQuickAddServiceItem() {
    const href = this.$router.resolve(
      `/setting/service-add?serviceItemName=${encodeURIComponent(this.noMatchingServiceItemName)}`
    ).href;
    window.open(href);
  }
  noMatchingPartsName = "";
  handleLinkQuickAddParts() {
    const href = this.$router.resolve(
      `/setting/parts-add?partsName=${encodeURIComponent(this.noMatchingPartsName)}`
    ).href;
    window.open(href);
  }
  handleTechnicianVisibleChange(visible, refKey, value) {
    if (!visible && value.length > 0 && this.technicianTipsAutoShow) {
      (this.$refs[refKey] as any).open();
      this.setTechnicianTipsAutoShow(false);
    }
  }
}
